"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.popoverConfig = exports.initialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.defaultPayload = exports.componentConfig = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var dropdownOptions = exports.dropdownOptions = {
  beneficiaryArray: ['just me', 'a dependent adult', 'my spouse/partner', 'my spouse/partner & kids', 'my kids'],
  numOfKidsArray: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
  planIndArray: ['plan', 'do not plan'],
  collegeTermArray: ['public 2-year', 'public 4-year in-state', 'public 4-year out-of-state', 'private 4-year'],
  numOfYearsReplacementArray: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
};
var popoverConfig = exports.popoverConfig = {
  spouseIncomeText: "Including spouse's income reduces recommended coverage.",
  childcareText: 'Estimate based on ZIP code and using data from Childcareaware.org.',
  healthcareText: 'Estimate based on ZIP code and data from HHS.gov with estimates made by MassMutual for those states not part of the health care marketplace platform.',
  earningsGrowthRateText: 'Represents the annual increase in salary you expect to receive through retirement.',
  inlfationRateText: 'Represents the increase in overall price levels.',
  collegeInflationRateText: 'The College Board provides detailed information by type of College; this calculator uses a 5% estimate.',
  burialCostText: "According to the <a href='https://nfda.org/news/media-center/nfda-news-releases/id/6182/2021-nfda-general-price-list-study-shows-funeral-costs-not-rising-as-fast-as-rate-of-inflation' target='_blank'>NFDA.org</a> the most recent average cost of a funeral with a vault was $9,420.",
  zipCode: 'ZIP code is used to estimate health and child care costs.',
  personalExpensesText: 'Increasing personal expenses reduces recommended coverage.'
};
var calcName = exports.calcName = 'life';
var idPrefix = exports.idPrefix = "li_";
var validationPage1 = yup.object().shape({
  birthMonth: yup.number('Month must be a number').required('You must specify a valid month').min(1, 'Invalid Month').max(12, 'Invalid Month'),
  birthDay: yup.number('Day must be a number').required('You must specify a valid day').min(1, 'Invalid Day').max(31, 'Invalid Day'),
  birthYear: yup.number().required('You must specify a valid year'),
  zipCode: yup.string().required('Please enter a valid ZIP code').length(5, 'Please enter a valid ZIP code').matches(/^[0-9]{5}$/, 'Please enter a valid ZIP code'),
  beneficiary: yup.string().required('You must select a beneficiary type').oneOf([dropdownOptions.beneficiaryArray]),
  birthdate: yup.date().typeError('Must be a valid date and between 18 and 100 years of age').required('Must be a valid date and between 18 and 100 years of age').min((0, _sub.default)(new Date(), {
    years: 100
  }), 'Must be a valid date and between 18 and 100 years of age').max((0, _sub.default)(new Date(), {
    years: 18
  }), 'Must be a valid date and between 18 and 100 years of age')
});
var validationPage2 = yup.object().shape({
  annualPay: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  mortgageAmount: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  otherDebt: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  numOfKids: yup.string().when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.string().required('Must be between 1-10 children').min(1, 'Must be between 1-10 children').max(10, 'Must be between 1-10 children').oneOf(dropdownOptions.numOfKidsArray)
  }),
  collegePlanInd: yup.string().when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.string().required('You must select a plan indiciator').oneOf(dropdownOptions.planIndArray)
  }),
  collegeTerm: yup.string().when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.string().required('You must select a college term').oneOf(dropdownOptions.collegeTermArray)
  }),
  dependentAge: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when('beneficiary', {
    is: beneficiary => beneficiary == 'a dependent adult',
    then: yup.number().required('Must be between 18-100 years old').min(18, 'Must be between 18-100 years old').max(100, 'Must be between 18-100 years old')
  }),
  partnerAge: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse/partner' || beneficiary == 'my spouse/partner & kids',
    then: yup.number().required('Must be between 12-100 years old').min(12, 'Must be between 12-100 years old').max(100, 'Must be between 12-100 years old')
  }),
  child1Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child2Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 1;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child3Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 2;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child4Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 3;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child5Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 4;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child6Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 5;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child7Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 6;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child8Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 7;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child9Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 8;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  }),
  child10Age: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when(['beneficiary', 'numOfKids'], {
    is: (beneficiary, numOfKids) => {
      return (beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids') && numOfKids > 9;
    },
    then: yup.number().required('Must be between 0-21 years old').min(0, 'Must be between 0-21 years old').max(21, 'Must be between 0-21 years old')
  })
});
var validationPage3Additions = yup.object().shape({
  spouseIncome: yup.number().transform(_utils.parseCurrencyString).when('beneficiary', {
    is: beneficiary => beneficiary == 'my spouse/partner' || beneficiary == 'my spouse/partner & kids',
    then: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000')
  }),
  numOfYearsReplacement: yup.string().required(),
  childCareCost: yup.number().transform(_utils.parseCurrencyString).when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.number().transform(_utils.parseCurrencyString).notRequired().min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000')
  }),
  healthCareCost: yup.number().transform(_utils.parseCurrencyString).when('beneficiary', {
    is: beneficiary => beneficiary == 'my kids' || beneficiary == 'my spouse/partner & kids',
    then: yup.number().transform(_utils.parseCurrencyString).notRequired().min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000')
  }),
  burialCost: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  personalExpenses: yup.number().transform(parseFloat).required('Must be between 0% and 50% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 50% and to a maximum of 2 decimal places').max(50, 'Must be between 0% and 50% and to a maximum of 2 decimal places'),
  savingAmount: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  existingLifeInsurance: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  earningsGrowthRate: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
  inflationRate: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places'),
  rateOfReturn: yup.number().transform(parseFloat).required('Must be between 0% and 15% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 15% and to a maximum of 2 decimal places').max(15, 'Must be between 0% and 15% and to a maximum of 2 decimal places'),
  collegeInflationRate: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places')
});

// Using the configs from page 1 and 2 and then mixing in our additional shapes
var validationPage3 = validationPage1.concat(validationPage2).concat(validationPage3Additions);
var validationConfig = exports.validationConfig = [validationPage1, validationPage2, validationPage3];
var initialValuesConfig = exports.initialValuesConfig = {
  birthMonth: '',
  birthDay: '',
  birthYear: '',
  zipCode: '',
  beneficiary: '',
  annualPay: '',
  mortgageAmount: '',
  otherDebt: '',
  dependentAge: '',
  partnerAge: '',
  numOfKids: '1',
  child1Age: '',
  child2Age: '',
  child3Age: '',
  child4Age: '',
  child5Age: '',
  child6Age: '',
  child7Age: '',
  child8Age: '',
  child9Age: '',
  child10Age: '',
  collegePlanInd: 'plan',
  collegeTerm: 'private 4-year',
  spouseIncome: '0',
  numOfYearsReplacement: '10 Years',
  childCareCost: '',
  healthCareCost: '',
  burialCost: '9,420',
  personalExpenses: '10',
  savingAmount: '0',
  existingLifeInsurance: '0',
  earningsGrowthRate: '2',
  inflationRate: '2',
  rateOfReturn: '4',
  collegeInflationRate: '5',
  incomeReplacementRate: '100',
  retirementAge: '65',
  useDefault: 'No',
  dateOfBirth: ''
};
var initialTouchedConfig = exports.initialTouchedConfig = {
  birthMonth: false,
  birthDay: false,
  birthYear: false
};
var defaultPayload = exports.defaultPayload = {
  age10: 0,
  age1: 0,
  age2: 0,
  age3: 0,
  age4: 0,
  age5: 0,
  age6: 0,
  age7: 0,
  age8: 0,
  age9: 0,
  annualEarnedIncome: 0,
  burialCost: 8755,
  childCareRate: 100,
  college10: 'Private Nonprofit Four-Year',
  college1: 'Private Nonprofit Four-Year',
  college2: 'Private Nonprofit Four-Year',
  college3: 'Private Nonprofit Four-Year',
  college4: 'Private Nonprofit Four-Year',
  college5: 'Private Nonprofit Four-Year',
  college6: 'Private Nonprofit Four-Year',
  college7: 'Private Nonprofit Four-Year',
  college8: 'Private Nonprofit Four-Year',
  college9: 'Private Nonprofit Four-Year',
  collegeInflationRate: 0.05,
  currentAge: 55,
  earningsGrowthRate: 0.02,
  existingLifeInsurance: 0,
  family: 'Me, Spouse/Partner & Kids',
  healthCareRate: 100,
  incomeReplacementRate: 100,
  inflationRate: 0.02,
  mortgage: 100,
  numOfChildren: 1,
  numOfYearsReplacement: 10,
  otherDebt: 0,
  personalExpenses: 0.1,
  rateOfReturn: 0.04,
  retirementAge: 65,
  savingAmount: 0,
  spouseAge: 0,
  spouseIncome: 0,
  useDefault: 'No',
  zip_code: '01108'
};
var componentConfig = exports.componentConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/lifeInsurance_v0.24.01',
    Steps: [{
      Title: 'How much life insurance do I need?',
      Description: '',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: 'Life insurance can help you protect the ones you love and give them one less thing to worry about.',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Compare policy types',
          Href: '',
          Target: '',
          Variant: 'link'
        }, {
          Label: 'Buy term life insurance online',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }, {
      Title: 'How much life insurance do I need?',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: 'Life insurance can help you protect the ones you love and give them one less thing to worry about.',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Compare policy types',
          Href: '',
          Target: '',
          Variant: 'link'
        }, {
          Label: 'Buy term life insurance online',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }, {
      Title: 'How much life insurance do I need?',
      Description: 'Your estimated life insurance coverage need',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next step',
        Description: 'Life insurance can help you protect the ones you love and give them one less thing to worry about.',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Compare policy types',
          Href: '',
          Target: '',
          Variant: 'link'
        }, {
          Label: 'Buy term life insurance online',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};